import React from 'react';
import { CheckCircle, ShieldCheck, Play, Microscope, Info } from 'lucide-react';

const AbapUnitWizard = ({ data = {}, setData }) => {
  
  const handleToggle = (option) => {
    setData({
      ...data,
      unitOptions: { ...data.unitOptions, [option]: !data.unitOptions[option] }
    });
  };

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left">
      
      {/* NOTA DEL INGENIERO DE QA / ABAP */}
      <div className="bg-emerald-900/10 border-l-4 border-emerald-600 p-6 mb-10 rounded-r-3xl flex gap-4 items-start shadow-sm">
        <div className="bg-emerald-600 p-2 rounded-xl text-white shadow-lg shadow-emerald-500/20 shrink-0">
            <CheckCircle size={20}/>
        </div>
        <div>
            <p className="text-[11px] text-emerald-800 font-black uppercase tracking-widest mb-1 italic">ABAP Unit Quality Guide:</p>
            <p className="text-[11px] text-slate-600 leading-relaxed font-medium">
                Esta herramienta genera clases de prueba locales (**Local Test Classes**) siguiendo el estándar de SAP. 
                Es fundamental definir el objeto bajo prueba (CUT) y el escenario. La IA generará la estructura con las anotaciones 
                <code className="bg-emerald-100 px-1 rounded text-emerald-700">FOR TESTING</code>, niveles de riesgo y duración, 
                además de los métodos de aserción usando la clase <code className="bg-emerald-100 px-1 rounded text-emerald-700">cl_abap_unit_assert</code>.
            </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
        
        {/* CONFIGURACIÓN TÉCNICA DE LA PRUEBA */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-emerald-500 text-left">
          <label className="text-[10px] font-black text-emerald-400 uppercase block mb-6 border-b border-slate-800 pb-2 flex items-center gap-2">
            <Microscope size={14}/> Test Class Configuration
          </label>
          
          <div className="space-y-5">
            <div>
              <label className="text-[9px] font-bold text-slate-500 uppercase block mb-1">Clase / Método a Testear</label>
              <input type="text" className="w-full p-3 bg-slate-800 border-none rounded-xl text-xs font-mono uppercase focus:ring-2 focus:ring-emerald-500 outline-none text-emerald-200" 
                placeholder="CL_SALES_HANDLER => PROCESS" value={data.unitTarget || ''} onChange={e => setData({...data, unitTarget: e.target.value})} />
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="text-[9px] font-bold text-slate-500 uppercase block mb-1">Risk Level</label>
                    <select className="w-full p-3 bg-slate-800 border-none rounded-xl text-xs font-bold outline-none focus:ring-2 focus:ring-emerald-500" 
                        value={data.unitRisk || 'HARMLESS'} onChange={e => setData({...data, unitRisk: e.target.value})}>
                        <option value="HARMLESS">HARMLESS (Sin Riesgo)</option>
                        <option value="DANGEROUS">DANGEROUS (Riesgo Crítico)</option>
                    </select>
                </div>
                <div>
                    <label className="text-[9px] font-bold text-slate-500 uppercase block mb-1">Duration</label>
                    <select className="w-full p-3 bg-slate-800 border-none rounded-xl text-xs font-bold outline-none focus:ring-2 focus:ring-emerald-500" 
                        value={data.unitDuration || 'SHORT'} onChange={e => setData({...data, unitDuration: e.target.value})}>
                        <option value="SHORT">SHORT (Segundos)</option>
                        <option value="LONG">LONG (Procesos pesados)</option>
                    </select>
                </div>
            </div>
          </div>
        </div>

        {/* MÉTODOS DE FIXTURE Y ESCENARIO */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-emerald-500 text-left">
          <label className="text-[10px] font-black text-emerald-400 uppercase block mb-6 border-b border-slate-800 pb-2 flex items-center gap-2">
                <Play size={14}/> Test Fixture & Scenario
            </label>
            <div className="space-y-4">
                <label className="flex items-center justify-between group cursor-pointer p-3 bg-slate-50 rounded-xl hover:bg-emerald-50 transition-all border border-transparent hover:border-emerald-100">
                    <span className="text-[10px] font-black text-slate-700 uppercase">Incluir método SETUP</span>
                    <input type="checkbox" className="w-5 h-5 rounded border-slate-300 text-emerald-600 focus:ring-0" 
                        checked={data.unitOptions?.setup || false} onChange={() => handleToggle('setup')} />
                </label>

                <label className="flex items-center justify-between group cursor-pointer p-3 bg-slate-50 rounded-xl hover:bg-emerald-50 transition-all border border-transparent hover:border-emerald-100">
                    <span className="text-[10px] font-black text-slate-700 uppercase">Incluir método TEARDOWN</span>
                    <input type="checkbox" className="w-5 h-5 rounded border-slate-300 text-emerald-600 focus:ring-0" 
                        checked={data.unitOptions?.teardown || false} onChange={() => handleToggle('teardown')} />
                </label>

                <div className="pt-4 mt-4 border-t border-slate-100">
                    <div className="flex items-center gap-2 text-emerald-600 mb-2">
                        <ShieldCheck size={16}/>
                        <span className="text-[10px] font-black uppercase">Seguridad de Ejecución</span>
                    </div>
                    <p className="text-[9px] text-slate-400 leading-relaxed font-medium">
                        El código generado incluirá validaciones automáticas para que el test no se ejecute en entornos Productivos si detecta cambios de base de datos.
                    </p>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default AbapUnitWizard;